import { z } from "zod";

export const DashboardConsultantProductionSchema = z.object({
    billed: z.object({
        daily_rate: z.number().optional(),
        das: z.object({}).optional(),
        production_objectives: z.number().optional()
    }),
    global: z.object({
        billed: z.number().optional(),
        billed_amount: z.number().optional(),
        internal_projects: z.number().optional(),
        non_billed: z.number().optional(),
        other: z.number().optional(),
        vacations: z.number().optional()
    }),
    lead: z.object({
        billed: z.number().optional(),
        deals: z.number().optional(),
        produced: z.number().optional()
    })
});

export type DashboardConsultantProduction = z.infer<typeof DashboardConsultantProductionSchema>;
export const DashboardConsultantProductionPartialSchema = DashboardConsultantProductionSchema.partial();
export type DashboardConsultantProductionPartial = z.infer<typeof DashboardConsultantProductionPartialSchema>;

export function parseDashboardConsultantProduction(data: unknown, partial = false) {
    if (!partial) {
        return {
            ...DashboardConsultantProductionSchema.parse(data)
        };
    }

    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    
    if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }

    else {
        return {
            ...DashboardConsultantProductionSchema.parse(data)
        };
    }
}
